export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const PHONE_RE = /^\+?[1-9]\d{6,14}$/;

/**
 * Pure validation for external / mixed email recipient rows.
 * @param {Array<{ action?: string, email?: string, phone?: string }>} rows
 * @returns {{ ok: boolean, reason: 'atLeastOneSigner'|'emailInvalid'|'signerEmailRequired'|'phoneInvalid'|null }}
 */
export function validateExternalRecipients(rows) {
  if (!rows?.length) {
    return { ok: false, reason: 'atLeastOneSigner' };
  }
  const signers = rows.filter(r => r.action === 'signer');
  if (!signers.length) {
    return { ok: false, reason: 'atLeastOneSigner' };
  }
  const bad = rows.find(
    r => r.action === 'signer' && r.email && !EMAIL_RE.test(String(r.email).trim()),
  );
  if (bad) {
    return { ok: false, reason: 'emailInvalid' };
  }
  const emptySigner = signers.find(r => !r.email?.trim());
  if (emptySigner) {
    return { ok: false, reason: 'signerEmailRequired' };
  }
  const invalidPhone = signers.find(r => r.phone?.trim() && !PHONE_RE.test(String(r.phone).trim()));
  if (invalidPhone) {
    return { ok: false, reason: 'phoneInvalid' };
  }
  return { ok: true, reason: null };
}
